export default __webpack_public_path__ + "assets/images/53b9253c41f70d24f3af7e8b62ef0e35.jpg";